<template>
    <el-submenu
        v-if="menu.subMenus && menu.subMenus.length >= 1"
        :index="menu.id + ''">
        <template slot="title">
            <i :class="menu.icon"></i>
            <span>{{ menu.name }}</span>
        </template>
        <sub-menu
            v-for="item in menu.subMenus"
            :key="item.id"
            :menu="item"
            :dynamicMenuRoutes="dynamicMenuRoutes">
        </sub-menu>
    </el-submenu>
    <el-menu-item v-else :index="menu.id + ''" @click="gotoRouteHandle(menu)">
        <i :class="menu.icon"></i>
        <span>{{ menu.name }}</span>
    </el-menu-item>
</template>

<script>
    import SubMenu from './sub_menu'

    export default {
        name: 'sub-menu',
        props: {
            menu: {
                type: Object,
                required: true
            },
            dynamicMenuRoutes: {
                type: Array,
                required: true
            }
        },
        components: {
            SubMenu
        },
        computed: {
        },
        methods: {
            // 通过menuId与动态(菜单)路由进行匹配跳转至指定路由
            gotoRouteHandle(menu) {
                var route = this.dynamicMenuRoutes.filter(item => item.meta.id === menu.id)
                if (route.length >= 1) {
                    this.$router.push({name: route[0].name})
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sub_menu.vue